import { Kebab } from './Kebab';
import { IKebab } from './Kebab.interfaces';

export default Kebab;
export { Kebab, IKebab };
